function mtInitReveal() {
  const els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.mtDelay || 0;
          setTimeout(() => entry.target.classList.add('mt-visible'), Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach((el) => observer.observe(el));
}

function mtInitContadores() {
  const els = document.querySelectorAll('[data-mt-count]');
  if (!els.length) return;
  const animar = (el) => {
    const target = Number(el.dataset.mtCount || 0);
    const dur = 1400;
    const start = performance.now();
    const step = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString('es-ES');
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animar(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );
  els.forEach((el) => observer.observe(el));
}

function mtInitGaleriaProducto() {
  const wrap = document.querySelector('[data-mt-galeria]');
  if (!wrap) return;
  const principal = wrap.querySelector('[data-mt-galeria-principal]');
  const miniaturas = wrap.querySelectorAll('[data-mt-miniatura]');
  if (!principal || !miniaturas.length) return;
  miniaturas.forEach((mini) => {
    mini.addEventListener('click', () => {
      const src = mini.dataset.mtFull;
      const alt = mini.dataset.mtAlt || '';
      principal.querySelectorAll('img').forEach((img) => {
        img.src = src;
        img.srcset = '';
        img.alt = alt;
      });
      miniaturas.forEach((m) => m.classList.remove('mt-miniatura-activa'));
      mini.classList.add('mt-miniatura-activa');
    });
  });
}

function mtInitVariantes() {
  const forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach((form) => {
    const dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    let variantes = [];
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    const scope = form.closest('.mt-producto-compra') || form;
    const grid = form.closest('.mt-producto-grid');
    const galeriaPrincipal = grid ? grid.querySelector('[data-mt-galeria-principal]') : null;
    const miniaturas = grid ? grid.querySelectorAll('[data-mt-miniatura]') : [];
    const selects = form.querySelectorAll('[data-mt-opcion]');
    const idInput = form.querySelector('input[name="id"]');
    const precioEl = scope.querySelector('[data-mt-precio]');
    const precioCompareEl = scope.querySelector('[data-mt-precio-compare]');
    const btn = form.querySelector('[data-mt-add-btn]');
    const estadoEl = scope.querySelector('[data-mt-estado]');

    const actualizar = () => {
      const valores = Array.from(selects).map((s) => s.value);
      const match = variantes.find((v) => v.opciones.every((o, i) => o === valores[i]));
      if (!match) return;
      idInput.value = match.id;
      if (precioEl) precioEl.textContent = match.precio;
      if (precioCompareEl) {
        if (match.precioCompare) {
          precioCompareEl.textContent = match.precioCompare;
          precioCompareEl.style.display = '';
        } else {
          precioCompareEl.style.display = 'none';
        }
      }
      if (match.imagen && galeriaPrincipal) {
        galeriaPrincipal.querySelectorAll('img').forEach((img) => {
          img.src = match.imagen;
          img.srcset = '';
          img.alt = match.imagenAlt || '';
        });
        miniaturas.forEach((m) => {
          m.classList.toggle('mt-miniatura-activa', m.dataset.mtFull === match.imagen);
        });
      }
      if (btn) {
        btn.disabled = !match.disponible;
        btn.textContent = match.disponible ? btn.dataset.mtTextoDisponible : btn.dataset.mtTextoAgotado;
      }
      if (estadoEl) {
        estadoEl.textContent = match.disponible ? estadoEl.dataset.mtTextoDisponible : estadoEl.dataset.mtTextoAgotado;
        estadoEl.classList.toggle('mt-estado-agotado', !match.disponible);
      }
    };

    selects.forEach((s) => s.addEventListener('change', actualizar));
    actualizar();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  mtInitReveal();
  mtInitContadores();
  mtInitGaleriaProducto();
  mtInitVariantes();
});
